import * as axios from 'axios';

import { API } from './config';

const getAllData = async function() {
  let url;
  if (process.env.NODE_ENV === "development") {
    url = process.env.VUE_APP_API;
  } else if (process.env.NODE_ENV === "production") {
    url = document.querySelector(".tx_leicaobjectivefinder").dataset.json;
  }

  try {
    const response = await axios.get(url);
    let data = parseList(response);
    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const getFilters = async function() {
  try {
    const response = await axios.get(`${API}/filters.json`);
    let data = parseList(response);
    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const getXML = async function(urls) {
  try {
    let requests = [];
    urls.forEach((url) => {
      requests.push(axios.get(url));
    });
    return await axios.all(requests);
  } catch (error) {
    console.error(error);
    return [];
  }
};

const parseList = (response) => {
  if (response.status !== 200) throw Error(response.message);
  if (!response.data) return [];
  let list = response.data;
  return list;
};

export const data = {
  getAllData,
  getFilters,
  getXML,
};
